import React, {Component} from 'react';
import { Link } from 'react-router-dom';

class Trifles extends Component {

    render() {

        return (
            <div data-id={`${this.props.sideImage}`} className="swiper-slide">
                <div className={`side_image side_image-${this.props.sideImage}`}/>
                <div className="trifles-page page">
                    <div className="trifles__content page__content visible-content">
                        <h2>Speisekarte (Kleinigkeiten)
                        </h2>
                        <p className="closed-notice">Vorübergehend geschlossen</p>
                        <div className="page_description">
                            <p>Trifles menu</p>
                        </div>
                        <Link to="/menu" className="btn">
                            <div className="front">Café</div>
                            <div className="back">Café</div>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default Trifles;
